import { PropTypes } from "@l2r-front/l2r-proptypes"
import { useIsMobileDevice } from "@l2r-front/l2r-ui"

import { SimpleAppBar } from "../../containers/SimpleAppBar"

import * as Styled from "./MessagePage.styled"

export const MessagePage = (props) => {

    const {
        children,
    } = props

    const isMobile = useIsMobileDevice()

    return (
        <Styled.PageContainer>
            {!isMobile && <SimpleAppBar />}
            {children}
        </Styled.PageContainer>
    )
}

MessagePage.propTypes = {
    children: PropTypes.node,
}